<template>
  <section class="section" id="credits-panel">
    <product-creation-title />

    <product-creation-form />

    <product-creation-rules />
  </section>
</template>

<script>
import productCreationTitle from "./ProductCreationTitle";
import productCreationForm from "./ProductCreationForm";
import productCreationRules from "./ProductCreationRules";

export default {
  components: {
    productCreationTitle,
    productCreationForm,
    productCreationRules
  }
};
</script>

<style scoped>
#credits-panel {
  margin-top: 3rem;
  min-height: 100vh;
  background-color: hsl(0, 0%, 96%);
}
</style>
